import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  gap: 4,
  backgroundColor: spaceCadet[100],
  '& > .MuiBox-root': {
    backgroundColor: 'white',
    border: `2px solid ${spaceCadet[100]}`,
    borderRadius: '4px',
    padding: '20px',
    boxShadow: `0 0 10px ${spaceCadet[300]}`,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    maxWidth: '600px',
    '& .MuiTypography-h4': {
      color: spaceCadet[800],
      fontSize: '24px',
      lineHeight: '24px',
      fontWeight: '700',
    },
    '& .MuiTypography-body2': {
      fontStyle: 'italic',
    },
    '& > .MuiBox-root.content': {
      flexGrow: 1,
      overflowY: 'auto',
      '& .MuiTypography-root': {
        margin: 0,
        fontStyle: 'italic',
      },
    },
  },
});

export default StyledBox;
